import { BasePage } from '@scalefast/core';
import { BuilderPage, ContentfulPage } from '../core/interfaces';

export function isContentfulPage(pageData: BasePage): pageData is ContentfulPage {
  return pageData.pageProvider === 'contentful';
}

export function isBuilderPage(pageData: BasePage): pageData is BuilderPage {
  return pageData.pageProvider === 'builder.io';
}
